module.exports = __webpack_public_path__ + "img/1.cfcf1af9.png";